import React from 'react';

const Buttons = ({ className, name, handleChangeSrc, src, police }) => {

    return <button onClick={handleChangeSrc} value={src} style={{fontFamily: police}} className={className}>{name}</button>
};

export default Buttons;